module.exports = __webpack_public_path__ + "static/media/samad.d1766bac.png";